import React, {useState, useRef} from 'react'
import {capitalCase} from 'change-case'
import {
    Badge,
    Box,
    Button,
    FormControlLabel,
    IconButton,
    Popover,
    SvgIcon,
    Switch,
    TextField,
    Tooltip,
    Typography,
    makeStyles,
    useMediaQuery
} from '@material-ui/core'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {Settings as SettingsIcon} from 'react-feather'
import useSettings from '../../../hooks/useSettings'
import {THEMES} from '../../../constants'
import {useTheme} from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
    badge: {
        height: 10,
        width: 10,
        borderRadius: 5,
        marginTop: 10,
        marginRight: 5
    },
    popover: {
        width: 320,
        padding: theme.spacing(2)
    },
    label: {
        marginRight: theme.spacing(2.25)
    },
    button: {
        padding: theme.spacing(0.5)
    },
    icon: {},
    mobileButton: {
        marginRight: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main + '!important',
        width: 32,
        height: 32,
        borderRadius: 16,
        fontSize: '1.3rem',
    }
}))

function Settings() {
    const classes = useStyles()
    const ref = useRef(null)
    const {settings, saveSettings} = useSettings()
    const [isOpen, setOpen] = useState(false)
    const [values, setValues] = useState({
        direction: settings.direction,
        responsiveFontSizes: settings.responsiveFontSizes,
        theme: settings.theme
    })

    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const handleChange = (field, value) => {
        const values = {
            ...values,
            [field]: value
        }
        setValues(values)

        setTimeout(() => {
            saveSettings(values)
        })
    }

    const handleSave = () => {
        saveSettings(values)
        setOpen(false)
    }

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
        defaultMatches: true
    })

    return (
        <>
            {!isMobile ? (
                <div>
                    <IconButton color="inherit" onClick={() => handleChange('theme', 'LIGHT')} className={classes.label + ' ' + classes.button}>
                        <FontAwesomeIcon size={'sm'} icon={['fas', 'sun']} className={classes.icon}/>
                    </IconButton>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={values.theme === 'DARK'}
                                edge="start"
                                name="direction"
                                onChange={event => handleChange('theme', event.target.checked ? 'DARK' : 'LIGHT')}
                            />
                        }
                        label={
                            <IconButton color="inherit" className={classes.button} onClick={() => handleChange('theme', 'DARK')}>
                                <FontAwesomeIcon size={'xs'} icon={['far', 'moon']} className={classes.icon}/>
                            </IconButton>
                        }
                    />
                </div>
            ) : (
                <div>
                    <IconButton
                        color="inherit"
                        onClick={event => handleChange('theme', values.theme === 'DARK' ? 'LIGHT' : 'DARK')}
                        className={classes.button + ' ' + classes.mobileButton}
                    >
                        <FontAwesomeIcon size={'sm'} icon={['fas', values.theme === 'DARK' ? 'sun' : 'moon']} className={classes.icon}/>
                    </IconButton>
                </div>
            )}
            {false && (
                <Tooltip title="Settings">
                    <IconButton color="inherit" onClick={handleOpen} ref={ref}>
                        <SvgIcon fontSize="small">
                            <SettingsIcon/>
                        </SvgIcon>
                    </IconButton>
                </Tooltip>
            )}
            <Popover
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                classes={{paper: classes.popover}}
                anchorEl={ref.current}
                onClose={handleClose}
                open={isOpen}
            >
                <Typography variant="h4" color="textPrimary">
                    Settings
                </Typography>
                {false && (
                    <>
                        <Box mt={2} px={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={values.direction === 'rtl'}
                                        edge="start"
                                        name="direction"
                                        onChange={event => handleChange('direction', event.target.checked ? 'rtl' : 'ltr')}
                                    />
                                }
                                label="RTL"
                            />
                        </Box>
                        <Box mt={2} px={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={values.responsiveFontSizes}
                                        edge="start"
                                        name="direction"
                                        onChange={event => handleChange('responsiveFontSizes', event.target.checked)}
                                    />
                                }
                                label="Responsive font sizes"
                            />
                        </Box>
                    </>
                )}
                <Box mt={2}>
                    <TextField
                        fullWidth
                        label="Theme"
                        name="theme"
                        onChange={event => handleChange('theme', event.target.value)}
                        select
                        SelectProps={{native: true}}
                        value={values.theme}
                        variant="outlined"
                    >
                        {Object.keys(THEMES).map(theme => (
                            <option key={theme} value={theme}>
                                {capitalCase(theme)}
                            </option>
                        ))}
                    </TextField>
                </Box>
                <Box mt={2}>
                    <Button variant="contained" color="secondary" fullWidth onClick={handleSave}>
                        Save Settings
                    </Button>
                </Box>
            </Popover>
        </>
    )
}

export default Settings
